<template>
  <div class="ff-rate" :class="model">
    <div v-if="showHead" @click="(e)=>{this.$emit('rateClick',e.target.innerHTML)}" class="rate-head">
      <slot name="head">{{ head }}</slot>
    </div>
    <div class="rate-body"
      :style="'width:' + sum * (iconSize + 4) + 'px;height:' + iconSize +'px;line-height:'+ iconSize + 'px'"
      @mouseleave="handleMouseleave"
    >
      <div class="back">
        <i v-for="s in sum"
           :key="s"
           class="glyphicon glyphicon-star rate-icon rate-back"
           @mouseenter="handleMouseenter(s)"
           @click="handleClick(s)"
        ></i>
      </div>
      <div class="color">
        <i v-for="c in parseInt(currentCount)"
           :key="c"
           class="glyphicon glyphicon-star rate-icon rate-item"
           @mouseenter="handleMouseenter(c)"
           @click="handleClick(c)"
        ></i>
        <i class="glyphicon glyphicon-star rate-icon rate-item"
           v-if="currentCount > parseInt(currentCount)"
           @mouseenter="handleMouseenter(parseInt(currentCount)+1)"
           :style="'width:' + (currentCount-parseInt(currentCount))*iconSize + 'px'"></i>
      </div>
    </div>
    <div v-if="showText" class="rate-tail">
      <slot name="text">
        <span>{{ currentCount }} 分</span>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Rate',
  props: {
    model: {
      type: String,
      default: 'normal' // mini/normal/large
    },
    sum: { // 星星总颗数
      type: Number,
      default: 5
    },
    count: { // 点亮星星颗数
      type: [Number, String],
      default: 0
    },
    showHead: { // 前置标题是否显示
      type: Boolean,
      default: false
    },
    head: { // 前置标题
      type: String,
      default: ''
    },
    showText: {// 显示分数
      type: Boolean,
      default: false
    },
    disabled: {// 是否可以选择
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hoverCount: -1,
      isHover: false,
      clickCount: this.count
    }
  },
  computed: {
    currentCount: function () {
      const _self = this;
      let c;
      if (_self.isHover) c = _self.hoverCount;
      else c = _self.clickCount;
      return c
    },
    iconSize: function () {
      if (this.model === 'large') return 16;
      else if (this.model === 'mini') return 12;
      else return 14;
    }
  },
  watch: {
    count (value) {
      this.clickCount = value;
    }
  },
  methods: {
    handleMouseenter (value) {
      if (this.disabled) return;

      this.isHover = true;
      this.hoverCount = value;
    },

    handleMouseleave () {
      if (this.disabled) return;

      this.isHover = false;
      this.hoverCount = -1;
    },

    handleClick (value) {
      if (this.disabled) return;

      this.isHover = false;
      this.clickCount = value;
      this.$emit('on-change', value);
    }
  }
}
</script>
<style lang="less" scoped>
  .ff-rate {
  .rate-body {
    display: inline-block;
    position: relative;
    .back {
      position: absolute;
      display: inline-flex;
    }
    .color {
      position: absolute;
      display: inline-flex;
    }
    .rate-icon {
      display: inline-flex;
      &.rate-back {
        color: #DDDDDD;
      }
      &.rate-item {
        color: #F7C500;
        overflow: hidden;
      }
    }
  }
  &.large {
    @size: 16px;
    .rate-icon {
      height: @size;
      width: @size;
      font-size: @size;
      margin-right: 4px;
    }
  }
  &.normal {
    @size: 14px;
    .rate-icon {
      height: @size;
      width: @size;
      font-size: @size;
      margin-right: 4px;
    }
  }
  &.mini {
    @size: 12px;
    .rate-icon {
      height: @size;
      width: @size;
      font-size: @size;
      margin-right: 2px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/rate/rate.vue